import type { supabase as supabaseClient } from '../supabase';

/** Count opportunities whose record was first created in [from, to). */
export async function countNewLeadsCreatedBetween(
  supabase: typeof supabaseClient,
  businessId: string,
  createdFromInclusive: string,
  createdBeforeExclusive: string
): Promise<number> {
  const { count, error } = await supabase
    .from('pipeline_opportunities')
    .select('id', { count: 'exact', head: true })
    .eq('business_id', businessId)
    .not('created_at', 'is', null)
    .gte('created_at', createdFromInclusive)
    .lt('created_at', createdBeforeExclusive);

  if (error) {
    throw error;
  }

  return count ?? 0;
}
